<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('WriteOff.FinanceExpensesAllocation')"
    width="350px"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <el-form label-width="100px" label-position="left">
      <el-form-item :label="$t('WriteOff.chargeItem') + ':'">
        <cargo-advance-select
          no="chargeItemId"
          :select-type="TYPE_NAMES.basic_data_ChargeItem"
          :method-params="{ active: true }"
          filterable
          :placeholder="$t('WriteOff.SelectChargeItem')"
          :default-value="form.chargeItemId"
          :disabled="financeChargeShareModify"
          @parentCallBack="p=>{form.chargeItemId=p.value||0}"
        />
      </el-form-item>
      <el-form-item :label="$t('WriteOff.settleAccountsTo') + ':'">
        <cargo-advance-select
          no="accountId"
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{ active: true }"
          filterable
          :placeholder="$t('WriteOff.SelectAccountObject')"
          :default-value="form.accountId"
          :disabled="financeChargeShareModify"
          @parentCallBack="p=>{form.accountId=p.value||0}"
        />
      </el-form-item>
      <el-form-item :label="$t('WriteOff.ChargingDirection') + ':'">
        <el-select v-model="form.receivable" no="receivable" :disabled="financeChargeShareModify">
          <el-option v-for="(item,index) in RECEIVABLE_PAYABLE_TYPES" :key="index" :label="$getLangColumn(item)" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Oversea') + ':'">
        <el-select v-model="form.oversea" no="oversea">
          <el-option :label="$t('SeaExport.internal')" :value="false" />
          <el-option :label="$t('SeaExport.overseas')" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_FinancialDate') + ':'">
        <el-date-picker
          v-model="form.accountingDate"
          no="accountingDate"
          type="date"
          style="width: 100%"
          @change="refreshExchageRate"
        />
      </el-form-item>
      <el-form-item :label="$t('WriteOff.currency') + ':'">
        <cargo-advance-select
          no="currency"
          :select-type="TYPE_NAMES.basic_data_Currency"
          filterable
          :clearable="false"
          :default-value="form.currency"
          @parentCallBack="p=>{form.currency=p.value;refreshExchageRate()}"
        />
      </el-form-item>
      <el-form-item :label="$t('FinanceManage.charge_exchangeRate') + ':'">
        <num-input
          v-model="form.exchangeRate"
          no="exchangeRate"
          :precision="8"
          :truncated-precision="exchangeRatePrecision"
        />
      </el-form-item>
      <el-form-item :label="$t('WriteOff.amount') + ':'">
        <el-input :value="form.amount * (form.receivable ? -1 : 1)" disabled />
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button no="confirm" type="primary" @click="confirmHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="cancleHandler">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { RECEIVABLE_PAYABLE_TYPES } from '@/class/cargo/model/parameters/ChargeConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import { getObjectByCache } from '@/utils/basicDataCache'

export default {
  name: 'FinanceChargeShareDialog',
  components: { CargoAdvanceSelect, NumInput },
  props: {
    visible: { type: Boolean, required: true },
    receivable: { type: Boolean, required: true },
    currency: { type: String, required: true },
    exchangeRate: { type: Number, required: true },
    amount: { type: Number, required: true },
    financeChargeShareModify: { type: Boolean, default: false } // 子应用财务费用分摊固定费用名称、结算对象、收付类型
  },
  data() {
    return {
      TYPE_NAMES,
      RECEIVABLE_PAYABLE_TYPES,
      innerVisible: false,
      form: {
        chargeItemId: 0,
        accountId: 0,
        receivable: false,
        oversea: false,
        accountingDate: moment().format('yyyy-MM-DD'),
        currency: '',
        exchangeRate: 0,
        amount: 0
      }
    }
  },
  computed: {
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.form.currency)
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.form.receivable = this.receivable
          this.form.currency = this.currency
          this.form.exchangeRate = this.exchangeRate
          this.form.amount = this.amount
          if (this.financeChargeShareModify) {
            // 费用名称【银行手续费】
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'zhName', '银行手续费')
            if (chargeItem && chargeItem.itemId > 0) {
              this.form.chargeItemId = chargeItem.itemId
            }
            // 合作伙伴名称【银行】
            const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'chineseName', '银行')
            if (company && company.cmpIdx > 0) {
              this.form.accountId = company.cmpIdx
            }
            // 应付
            this.form.receivable = false
          }
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.form.chargeItemId = 0
        this.form.accountId = 0
        this.form.receivable = false
        this.form.oversea = false
        this.form.accountingDate = moment().format('yyyy-MM-DD')
        this.form.currency = ''
        this.form.exchangeRate = 0
        this.form.amount = 0
      }
    }
  },
  methods: {
    refreshExchageRate() {
      if (!this.form.accountingDate || !this.form.currency) {
        return
      }
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.$store.getters.currentOfficeId)
      this.form.exchangeRate = RateUtil.getForeignExchangeRateSafely(localCurrency, this.form.currency, this.form.accountingDate, 0)
      this.onExchangeRateChange()
    },
    confirmHandler() {
      const form = this.form
      if (!form.chargeItemId) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return
      }
      if (!form.accountId) {
        this.$message.warning(this.$t('Message.ClearingTheObjectCannotBeNull'))
        return
      }
      if (!form.accountingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FinancialDateCheckNull'))
        return
      }
      if (!form.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyCheckNull'))
        return
      }
      this.innerVisible = false
      this.$emit('confirmCallback', { ...this.form })
    },
    cancleHandler() {
      this.innerVisible = false
      this.$emit('cancelCallback')
    }
  }
}
</script>
